import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		password: Yup.string().test(
			"password",
			t("fill_required_fields"),
			function (value) {
				const { newPassword, confirmPassword } = this.parent;

				if (value && value.length < 6) {
					return this.createError({
						message: t("password_has_to_be_at_least_n_characters_long", {
							min: 6,
						}),
					});
				}

				if (!newPassword && !confirmPassword) {
					return true;
				}

				return !!value; // Otherwise, check if value exists
			}
		),
		newPassword: Yup.string()
			.test("newPassword", t("fill_required_fields"), function (value) {
				const { password, confirmPassword } = this.parent;
				return !confirmPassword ? true : !!value;
			})
			.min(
				6,
				t("password_has_to_be_at_least_n_characters_long", {
					min: 6,
				})
			),
		confirmPassword: Yup.string()
			.test("confirmPassword", t("fill_required_fields"), function (value) {
				const { password, newPassword } = this.parent;
				return !newPassword ? true : !!value;
			})
			.oneOf([Yup.ref("newPassword"), null], t("passwords_has_to_match"))
			.min(
				6,
				t("password_has_to_be_at_least_n_characters_long", {
					min: 6,
				})
			),
		loadFrom: Yup.date()
			.typeError(t("first_hour_in_range_is_required"))
			.nullable()
			.when("shouldUseCustomTimes", ([shouldUseCustomTimes], schema) => {
				return schema.test({
					name: "is-required",
					exclusive: true,
					message: t("first_hour_in_range_is_required"),
					test: (loadFrom) => {
						return !shouldUseCustomTimes || !!loadFrom;
					},
				});
			}),
		loadTo: Yup.date()
			.nullable()
			.notRequired()
			.when(
				["loadFrom", "shouldUseCustomTimes"],
				([loadFrom, shouldUseCustomTimes], schema) => {
					return schema.test({
						name: "is-after-start",
						exclusive: true,
						message: t("second_hour_in_range_has_to_be_greater_than_first"),
						test: (loadTo) => {
							const startTime =
								loadFrom && loadFrom.getHours() * 60 + loadFrom.getMinutes();
							const endTime =
								loadTo && loadTo.getHours() * 60 + loadTo.getMinutes();

							return (
								!shouldUseCustomTimes ||
								!loadFrom ||
								!loadTo ||
								startTime < endTime
							);
						},
					});
				}
			),
		unloadFrom: Yup.date()
			.typeError(t("first_hour_in_range_is_required"))
			.nullable()
			.when("shouldUseCustomTimes", ([shouldUseCustomTimes], schema) => {
				return schema.test({
					name: "is-required",
					exclusive: true,
					message: t("first_hour_in_range_is_required"),
					test: (unloadFrom) => {
						return !shouldUseCustomTimes || !!unloadFrom;
					},
				});
			}),
		unloadTo: Yup.date()
			.nullable()
			.notRequired()
			.when(
				["unloadFrom", "shouldUseCustomTimes"],
				([unloadFrom, shouldUseCustomTimes], schema) => {
					return schema.test({
						name: "is-after-start",
						exclusive: true,
						message: t("second_hour_in_range_has_to_be_greater_than_first"),
						test: (unloadTo) => {
							const startTime =
								unloadFrom &&
								unloadFrom.getHours() * 60 + unloadFrom.getMinutes();
							const endTime =
								unloadTo && unloadTo.getHours() * 60 + unloadTo.getMinutes();

							return (
								!shouldUseCustomTimes ||
								!unloadFrom ||
								!unloadTo ||
								startTime < endTime
							);
						},
					});
				}
			),
	});
};
